import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { setdata } from "../../../../../../../../helpers/helpers";

export default function PriceDetails(props) {
  const { StepCheck, Plist, Charge } = props;

  return (
    <>
      <Row
        style={{
          backgroundColor: "var(--color-brand)",
          textAlign: "center",
          // border: "1px solid black",
          color: "var(--color-ui-surface)",
        }}
      >
        <small>
          <b className="modal__shipment_confirmation_sec_title">
            Shipment Breakdown
          </b>
        </small>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Carrier: </b>
              </small>
            </Col>
            <Col md={6}>
              <img
                src={setdata(
                  () => StepCheck["SingleQuoteData"]["img"],
                  false,
                  ""
                )}
                style={{ width: 99, height: 38 }}
              />
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Service Type: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["service_type"],
                  false
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>No. of Packages: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {Plist.length}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Total Weight: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {StepCheck["TotalWeight"]}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Est Transit days: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["transit_days"],
                  false
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Est Delivery date: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["delivery_date"],
                  true
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Base Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["base_charge"],
                  false
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>SubTotal Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {Charge?.sub_total ?? "0"}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Total Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>{Charge?.total ?? "0"}</b>
              </small>
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row style={{ textAlign: "center" }}>
            <small className="modal__shipment_confirmation_list_detail">
              <b>Additional Charges</b>
            </small>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Residential Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["residential_charge"],
                  false
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Signature Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["signature_charge"],
                  false
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Fuel Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["fuel_charge"],
                  false
                )}
              </small>
            </Col>
          </Row>
          <Row className="my-1">
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                <b>Freight Charge: </b>
              </small>
            </Col>
            <Col md={6}>
              <small className="modal__shipment_confirmation_list_detail">
                {setdata(
                  () => StepCheck["SingleQuoteData"]["freight_charge"],
                  false
                )}
              </small>
            </Col>
          </Row>
          {StepCheck?.SingleQuoteData?.tailgate_charge && (
            <>
              <Row className="my-1">
                <Col md={6}>
                  <small>
                    <b>Tailgate Charge: </b>
                  </small>
                </Col>
                <Col md={6}>
                  <small>
                    {setdata(
                      () => StepCheck["SingleQuoteData"]["tailgate_charge"],
                      false
                    )}
                  </small>
                </Col>
              </Row>
            </>
          )}
          {StepCheck?.SingleQuoteData?.insurance_charge && (
            <>
              <Row className="my-1">
                <Col md={6}>
                  <small className="modal__shipment_confirmation_list_detail">
                    <b>Insurance Charge: </b>
                  </small>
                </Col>
                <Col md={6}>
                  <small className="modal__shipment_confirmation_list_detail">
                    {setdata(
                      () => StepCheck["SingleQuoteData"]["insurance_charge"],
                      false
                    )}
                  </small>
                </Col>
              </Row>
            </>
          )}
          {StepCheck["SingleQuoteData"]["additional_charges"]?.map(
            (charge, index) => (
              <Row className="my-1" key={index}>
                <Col md={6}>
                  <small className="modal__shipment_confirmation_list_detail">
                    <b>{charge.NameEn}: </b>
                  </small>
                </Col>
                <Col md={6}>
                  <small className="modal__shipment_confirmation_list_detail">
                    {charge.Charge}
                  </small>
                </Col>
              </Row>
            )
          )}
          <Row style={{ textAlign: "center" }}>
            <small className="modal__shipment_confirmation_list_detail">
              <b>Tax Charges</b>
            </small>
          </Row>
          {Charge?.tax_charges?.map((tax, index) => (
            <Row className="my-1" key={index}>
              <Col md={6}>
                <small className="modal__shipment_confirmation_list_detail">
                  <b>{tax.NameEn}: </b>
                </small>
              </Col>
              <Col md={6}>
                <small className="modal__shipment_confirmation_list_detail">
                  {tax.Charge}
                </small>
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    </>
  );
}
